// this composable makes sure that we can use the same cookie refs throughout the app
let languageCookie: Ref<string | undefined>;
let countryCookie: Ref<string | undefined>;

export const useCountryLanguageCookies = () => {
    if (import.meta.client) {
        languageCookie ||= useCookie<string>('language');
        countryCookie ||= useCookie<string>('country');
    } else {
        languageCookie = useCookie<string>('language');
        countryCookie = useCookie<string>('country');
    }

    return { languageCookie, countryCookie };
};
